import { Link } from "react-router-dom";
import type { HospitolSetupStatus } from "@/core/setup/hospitol-setup-store";
import {
  buildHospitolSetupStatusMessage,
  isHospitolSetupComplete,
} from "@/core/setup/setup-status.util";
import { routes } from "@/router/all_routes";

interface HospitolSetupStatusBannerProps {
  status: HospitolSetupStatus | null;
  showWhenComplete?: boolean;
  showWhenIncomplete?: boolean;
}

export function HospitolSetupStatusBanner({
  status,
  showWhenComplete = false,
  showWhenIncomplete = true,
}: HospitolSetupStatusBannerProps) {
  if (!status) return null;

  if (isHospitolSetupComplete(status)) {
    if (!showWhenComplete) return null;
    return (
      <div className="alert alert-info small mb-3">
        Mise en route finalisée. Vous pouvez rouvrir l&apos;assistant pour mettre à jour les
        paramètres ou ajouter un partenariat assureur.
      </div>
    );
  }

  const message = buildHospitolSetupStatusMessage(status);
  if (!message || !showWhenIncomplete) return null;

  const setupHref =
    message.ctaStep && message.ctaStep > 1
      ? `${routes.hospitolSetup}?step=${message.ctaStep}`
      : routes.hospitolSetup;

  return (
    <div
      className={`alert alert-${message.variant} small mb-3 d-flex flex-wrap justify-content-between align-items-center gap-2`}
    >
      <div>
        <strong>{message.title}</strong>
        <div className="mt-1">{message.detail}</div>
        <div className="mt-1 text-muted">Progression : {status.progressPercent} %</div>
      </div>
      <Link to={setupHref} className="btn btn-sm btn-outline-dark flex-shrink-0">
        Continuer la mise en route
      </Link>
    </div>
  );
}
